export default import.meta.ROLLDOWN_FILE_URL_BLuy9iHSHEMW1J$kGVoNHg